class NavMenus {

    constructor() {
        this.navMenuComponents = [];
    };

    add(navMenuComponent) {
        this.navMenuComponents.push(navMenuComponent);
    };

    closeAll() {
        this.navMenuComponents.forEach((navMenuComponent) => {
            if (navMenuComponent && typeof navMenuComponent.close == 'function') {
                navMenuComponent.close();
            }
        })
    };

    closeOthers(navMenuComponent) {
        this.navMenuComponents.forEach((otherNavMenuComponent) => {
            if (otherNavMenuComponent && otherNavMenuComponent !== navMenuComponent && typeof otherNavMenuComponent.close == 'function') {
                otherNavMenuComponent.close();
            }
        })
    }

}

// We create and export a singleton instance of NavMenus because there should only be one instance we ever reference.
// FIXME - This singleton instance is shared only within each JS "pack" file. To truly share the instance it needs to be defined on the window object.
const singletonInstance = new NavMenus();
// Object.freeze(singletonInstance);
export default singletonInstance;
